import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

const EmptyItemsList = (props) => {
  return (
    props.show ? (
      <div className="empty-message">
          <span>
            <span>There are no Items for this Package yet.</span>
          </span>
      </div>
    ): null
  );
}

const ItemTableRow = (props) => {
  return (
    <tr>
      <td>
        <NavLink to={`/inventory/${props.item.id}/`}>
          {props.item.id}
        </NavLink>
      </td>
      <td>{props.item.item.name}</td>
      <td className="hidden-xxs-down">{props.item.station.name}</td>
      <td className="hidden-xs-down">{(props.item.extra_info && props.item.extra_info.grade)? props.item.extra_info.grade.grade: 'N/A'}</td>
      <td className="hidden-xs-down">{props.item.brand? props.item.brand.brand_name : '-'}</td>
      <td>
        <div className="d-flex">
          <span>{props.item.weight}</span>
          <span className="measureUnit ml-025">
            <span className="badge badge-pill badge-info"> {props.item.item.measure_unit? props.item.item.measure_unit : 'kg'}</span>
          </span>
        </div>
      </td>
      <td>{props.item.number_items}</td>
      <td className="hidden-xs-down">{props.item.packing_date}</td>
    </tr>)
  }

const ItemTableRows = (props) => {
  return (
    <tbody>
      {props.items.map((item,idx) => {
          return <ItemTableRow item={item} key={idx}/>
        })
      }
    </tbody>
  );
}

export default class PackageItemList extends Component {

  render() {
      return (
        <div>
          <table className="table table-striped table-hover mb-0">
            <thead className="thead-inverse">
              <tr>
                <th>Id</th>
                <th>Item</th>
                <th className="hidden-xxs-down">Station</th>
                <th className="hidden-xs-down">Grade</th>
                <th className="hidden-xs-down">Brand</th>
                <th>Qty</th>
                <th>Pieces</th>
                <th className="hidden-xs-down">Pack date</th>
              </tr>
            </thead>
            <ItemTableRows items={this.props.items}/>
          </table>
          <EmptyItemsList show={this.props.items.length === 0}/>
        </div>
      );
  }
}
